import { ReactKeycloakProvider } from '@react-keycloak/web';
import { useNavigate } from 'react-router-dom';
import keycloak, { keycloakLogout } from './config/keycloak';
import AppRouter from './AppRouter';

import { $user, setUser, type User } from 'models/user';
import { KeycloakTokenParsed } from 'keycloak-js';
import { useUnit } from 'effector-react';
import toast from 'react-hot-toast';

const eventLogger = async (event: unknown, error: unknown) => {
  if (event === 'onTokenExpired') {
    try {
      const refreshed = await keycloak.updateToken(30);

      if (!refreshed) {
        keycloakLogout(keycloak);
      }
    } catch (e) {
      console.error('Ошибка при обновлении токена:', e);
      keycloakLogout(keycloak);
    }
  }

  if (error) {
    toast.error(`Ошибка: ${error}`);
  }
};

const LoadingComponent = () => (
  <div className="flex items-center justify-center min-h-screen bg-gray-100">
    <div className="text-xl text-gray-600">Подключение к Keycloak...</div>
  </div>
);

const App = () => {
  const user = useUnit($user);
  const navigate = useNavigate();

  const tokenLogger = () => {
    const tokenParsed: KeycloakTokenParsed = keycloak.tokenParsed!;

    if (tokenParsed) {
      setUser({
        ...tokenParsed,
        groups: Array.isArray(tokenParsed.groups) ? tokenParsed.groups : [],
      } as User);
    }

    if (!tokenParsed && user) {
      const encodedRef = encodeURIComponent(location.pathname);
      navigate(`/login?ref=${encodedRef}`);
    }
  };

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      onEvent={eventLogger}
      onTokens={tokenLogger}
      LoadingComponent={<LoadingComponent />}
    >
      <AppRouter />
    </ReactKeycloakProvider>
  );
};

export default App;
